export default function CartDeliverySkeleton() {
  return (
    <div className="mx-2">
      <div
        className={
          'px-2 py-2 h-12 animate-pulse flex items-center text-sm cursor-pointer bg-gray-100 dark:bg-zinc-500 rounded-full'
        }></div>
    </div>
  )
}
